module.exports = __webpack_public_path__ + "img/Visa_Brandmark_Blue_RGB_2021.75bc3e57.svg";